import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { DateTime } from 'luxon';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';

import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

import useApp from 'app/context/useApp';
import useApi from 'app/context/useApi';

import RedButton from'app/components/buttons/RedButton';
import Loading from'app/components/loaders/Loading';

const useStyles = makeStyles(theme => ({
    main: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        height: '100%',
        width: '100%'
    },
    container: {
        zIndex: 12,
        height: '100%',
    },
    loginContainer: {
        padding: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(4),
        maxWidth: '680px',
        position: 'relative'
    },
    icon: {
        color: theme.palette.error.main,
        fontSize: 80
    },
    center: {
        textAlign: 'center'
    },
    right: {
        textAlign: 'right'
    },
    marginTop: {
        marginTop: theme.spacing(3)
    }
}));

export default function AuthLayout(props) {

    const { app } = useApp();
    const api = useApi();
    const classes = useStyles();

    const [ loading, setLoading ] = useState(false);

    const handleLogout = () => {

        setLoading(true);

        const bearerToken = api.defaults.headers.common['Authorization'];
        const token = bearerToken.substr(bearerToken.indexOf(" ") + 1);

        api.delete('/oauth/token/' + token).catch(() => setLoading(false));
    };

    return (
        <main className={classes.main}>
            <Grid container alignItems="center" justify="center" className={classes.container}>
                <Grid item className={classes.loginContainer}>
                    <Paper className={classes.paper}>
                        <Loading isLoading={loading}/>
                        <Grid container spacing={3} justify="center">
                            <Grid item xs={12} sm={"auto"}>
                                <div className={classes.center}>
                                    <ErrorOutlineIcon className={classes.icon}/>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={true}>
                                <Typography variant="h6" component="h1" gutterBottom>Your account has been suspended...</Typography>
                                <Typography variant="subtitle2" color="textSecondary" component="h4">
                                    Your account was suspended on {DateTime.fromISO(app.user.restricted_at).toLocaleString(DateTime.DATETIME_FULL)}. This can be due to one of several reasons and can usually be reversed. Please contact {app.club ? 'our service provider' : ''} Club Apps at <Link color="secondary" href={"mailto:" + process.env.MIX_CA_SUPPORT_EMAIL} target="_blank">{process.env.MIX_CA_SUPPORT_EMAIL}</Link> to help with restoring your account.
                                </Typography>
                            </Grid>
                            <Grid item xs={"auto"} sm={12}>
                                <div className={classes.right}>
                                    <RedButton variant="contained" onClick={handleLogout} disabled={loading}>Logout</RedButton>
                                </div>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        </main>
    )
};
